<div class="select-date select-date-start">
  <span class="select-date-label">{{ 'appointment_start_date_and_time' | translate }}</span>
  <span class="select-date-value" (click)="openDatesModal()" tappable>{{ startedAt | CompanyLocalized: 'dateAt' }}</span>
</div>
<div class="select-date">
  <span class="select-date-label">{{ 'appointment_end_date_and_time' | translate }}</span>
  <span class="select-date-value">{{ endedAt | CompanyLocalized: 'dateAt' }}</span>
</div>
